import { useMemo } from 'react';
import { theme as antdTheme, type ThemeConfig } from 'antd';
import { useTheme } from 'styled-components';

/**
 * The antd pieces of the board, dark and in the app's body font: left alone, antd draws its own light palette
 * and system font, which reads as another product next to the rest of the board.
 */
export function useDatasetAntdTheme(): ThemeConfig {
  const theme = useTheme();

  return useMemo(
    () => ({
      algorithm: antdTheme.darkAlgorithm,
      token: {
        // The body font of the app, set by the design system typography, rather than antd's own stack.
        fontFamily: 'inherit',
        colorBgElevated: theme.colors.neutral.palette800,
        colorBorder: theme.colors.neutral.palette700,
        colorText: theme.colors.neutral.white,
      },
    }),
    [theme]
  );
}
